import http from '../http'

/**
 * 健康检查API
 * 用于检查后端服务和数据库连接状态
 * @returns {Promise} 返回健康检查结果
 */
export function checkHealth() {
  return http.get('/health')
}

export default {
  checkHealth
}